import Navbar from './components/Navbar';
import CompanySection from './components/CompanySection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <CompanySection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
